import React, { useContext } from 'react';
import { Checkbox } from '@material-ui/core';
import { Cell } from 'react-table';
import { useMemoOne } from 'use-memo-one';
import { TableStateContext } from '../../../../contexts/tableState/TableStateContext';
import { PackagesList } from '../../../../utils/reducer';

function RowCheckbox({
  cell,
  tableName,
  propNameForId,
}: {
  tableName: string;
  cell: Cell<any>;
  propNameForId: string;
}) {
  const id = cell.row.original[propNameForId];

  const { state, setCheckedRow } = useContext(TableStateContext);

  const isChecked: boolean = useMemoOne((): boolean => {
    const list = new PackagesList(state[tableName]?.checkedIds || [], id);

    return list.containCheckedId();
  }, [state]);

  return <Checkbox checked={isChecked} onChange={() => setCheckedRow(tableName, id)} />;
}

export default RowCheckbox;
